import app from 'app';
import collectionMain from './collection/collection-main-js';

app.add({
  collectionMain,
});
app.mount();
